import * as React from "react"
import { 
  TextInput, 
  ImageInput, 
  ImageField, 
  ArrayInput, 
  SimpleFormIterator,
  required
} from "react-admin"
import { useEffect, useRef } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { Grid } from "@mui/material"
import isEqual from "lodash/isEqual"; 
import HexColorPicker from "../components/HexColorPicker"

const EditableAreasTab = () => {
  const { setValue, getValues } = useFormContext();
  const editableAreas = useWatch({ name: 'editableAreas' });

  const preAreasRef = useRef([]);

  useEffect(() => {
    const currentAreas = editableAreas || [];
  
    const updatedAreaNames = currentAreas.map(a => a?.areaName || "");
  
    if (isEqual(preAreasRef.current, updatedAreaNames)) return;
    preAreasRef.current = updatedAreaNames;
  
    const colors = getValues('colors');
  
    // 如果最後一筆 images 為空陣列，才自動補上對應顏色
    const lastIndex = currentAreas.length - 1;
    if (
      currentAreas.length > 0 &&
      Array.isArray(currentAreas[lastIndex]?.images) &&
      currentAreas[lastIndex].images.length === 0
    ) {
      const newAreas = [...currentAreas];
      newAreas[lastIndex] = {
        ...newAreas[lastIndex],
        images: colors.map(color => ({
          name: color.name,
          image: [],
        })),
      };
  
      setValue('editableAreas', newAreas);
    }
  }, [editableAreas, getValues, setValue]);
  

  return (
    <Grid container width={{ xs: "100%", xl: 800 }} spacing={2}>
      <Grid item xs={12} sm={12}>
        <HexColorPicker
          source="editableLineColor"
          label="編輯區域框線"
          validate={[required()]}
          defaultHex="000000"
          autofillOnMount
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <HexColorPicker
          source="editableLineBackgroundColor"
          label="區域標籤背景"
          validate={[required()]}
          defaultHex="000000"
          autofillOnMount
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <HexColorPicker
          source="editableLineTextColor"
          label="區域標籤文字"
          validate={[required()]}
          defaultHex="000000"
          autofillOnMount
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <ArrayInput source="editableAreas" label="編輯區域">
          <SimpleFormIterator getItemLabel={index => `#${index + 1}`}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextInput source="areaName" label="名稱" />
              </Grid>
              <Grid item xs={12}>
                <ImageInput 
                  source="templateImage" 
                  label="區域模板圖片" 
                  accept={{ 'image/png': ['.png'] }}
                  sx={{
                    "& .previews": {
                      backgroundColor: "#f0f0f0",
                      padding: "10px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    },
                  }}
                >
                  <ImageField source="src" title="title" />
                </ImageInput>
              </Grid>
              <Grid item xs={12}>
                <ArrayInput source="images" label="顏色對應圖片">
                  <SimpleFormIterator getItemLabel={index => `#${index + 1}`} disableAdd disableClear disableRemove disableReordering>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextInput source="name" label="名稱" readOnly/>
                      </Grid>
                      <Grid item xs={12}>
                        <ImageInput 
                          source="image" 
                          label="對應商品圖" 
                          accept={{ 'image/*': ['.png', '.jpg'] }}
                          sx={{
                            "& .previews": {
                              backgroundColor: "#f0f0f0",
                              padding: "10px",
                              borderRadius: "4px",
                              border: "1px solid #ccc",
                            },
                          }}
                        >
                          <ImageField source="src" title="title" />
                        </ImageInput>
                      </Grid>
                    </Grid>
                  </SimpleFormIterator>
                </ArrayInput>
              </Grid>
            </Grid>
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>
    </Grid>
  )
}

export default EditableAreasTab;